import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {EventsService} from '../events/events.service';
import {AuthenticationService} from '../../authentication.service';
import {DomSanitizer} from '@angular/platform-browser';
import {GlobalService} from '../../global.service';
import {Router} from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'elastic-livestreams',
  templateUrl: './livestreams.component.html',
  styleUrls: ['./livestreams.component.scss']
})
export class LivestreamsComponent implements OnInit, OnDestroy {

  anybodyLive = false;
  upcomingBroadcasts = [];
  activeUrl = '';
  show = false;
  closed = false;
  timer: any;
  constructor(
    private eventsService: EventsService,
    private auth: AuthenticationService,
    private cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private globalService: GlobalService,
    private router: Router
  ) { }

  ngOnInit() {
    this.activeUrl = this.router.url;
    this.globalService.shuffle(this.globalService.content_creators);

    this.router.events.subscribe(Event => {
      if (this.auth.isLoggedIn()) {
        if (this.auth.currentUser.patreon == 0) {
          if ((this.activeUrl == '/' && this.router.url != '/')) {
            console.log("ROUTE CHANGED AND WE ARE NOT ON THE HOMEPAGE!");
            this.closed = false;
            setTimeout( () => {
              this.closed = true;
              this.cd.detectChanges();
            }, 3000);
            this.cd.detectChanges();
          }
        }
      } else {
        this.closed = false;
        setTimeout( () => {
          this.closed = true;
          this.cd.detectChanges();
        }, 3000);
        this.cd.detectChanges();
      }

      if (this.activeUrl != this.router.url) {
        this.activeUrl = this.router.url;
      }

    });

    let array = [];

    this.globalService.official_channels.forEach( (data: any) => {
      array.push(data);
    });
    this.globalService.content_creators.forEach( (data: any) => {
      array.push(data);
    });

    this.globalService.channelNames = _.cloneDeep(array);
    console.log(this.router.url);

    setTimeout( () => {
      this.getBroadcasts();
    }, 3000);

    this.timer = setInterval( () => {
      this.getBroadcasts();
    }, 60000);

    if (this.auth.isLoggedIn()) {
      if (this.auth.currentUser.patreon > 0) {
        this.closed = true;
      }
    }

  }

  getBroadcasts() {
    this.anybodyLive = false;

    this.eventsService.getUpcomingBroadcasts().subscribe(

      ( response: HttpEvent<any> ) => {

        switch (response.type) {
          case HttpEventType.Response:



            if (response.body.data.length > 0) {
              response.body.data.forEach( ( broadcast: any) => {
                broadcast.embedLink = this.sanitizer.bypassSecurityTrustResourceUrl(broadcast.embedLink);
                broadcast.live_date = new Date(broadcast.live_date);
                broadcast.is_live = new Date() > broadcast.live_date ? true : false;
                if (broadcast.is_live) {
                  this.anybodyLive = true;
                }
                this.upcomingBroadcasts.push(broadcast);
              });
            }

            this.globalService.channelNames.forEach( (broadcast) => {
              if (broadcast.live && broadcast.link != undefined && !this.show) {
                // @ts-ignore
                this.show = broadcast;
                this.closed = false;
                setTimeout( () => {
                  this.closed = true;
                  this.cd.detectChanges();
                }, 3000);
                console.log("SHOW:");
                console.log(this.show);
              }
            });

            this.cd.detectChanges();
            console.log(this.upcomingBroadcasts);
            break;
        }
      });





  }

  ngOnDestroy() {

    clearInterval(this.timer);

  }

}
